import { ApiPageRequest } from "./api.types";

export interface SellTokenFormData {
  sellerId: string;
  numberOfTokens: number;
  paidAmount: number;
  transactionId?: string;
  transactionDate: string;
  paymentMethod: string;
}

export interface SalesListRequest extends ApiPageRequest<any> {
  startDate?: string;
  endDate?: string;
  sellerId?: string;
  retailerId?: string;
  buyerPhone?: string;
  sellerPhone?: string;
  paymentStatus?: string;
}

export interface SalesInfo {
  id: string;
  buyerName: string;
  buyerPhone: string;
  buyerOrganization: string;
  sellerName: string;
  sellerPhone: string;
  sellerOrganization: string;
  unitsSold: number;
  unitPrice: number;
  totalPayable: number;
  paidAmount: number;
  transactionDate: string;
  paymentMethod: string;
  transactionId: string;
  productType: string;
  paymentStatus: string;
}

export interface SalesReport {
  id: string;
  dealerName: string;
  retailerName: string;
  unitsSold: number;
  paidAmount: number;
  transactionId: string;
  transactionDate: string;
  paymentMethod: string;
}

export enum PaymentMethod {
  CASH = "CASH",
  BANK_TRANSFER = "BANK_TRANSFER",
  MOBILE_BANKING = "MOBILE_BANKING",
  CHEQUE = "CHEQUE",
  OTHER = "OTHER"
}

export enum PaymentStatus {
  PAID = "PAID",
  DUE = "DUE"
}

export interface PaymentRequest {
  salesId: number;
  amount: number;
  paymentMethod: string;
  transactionId?: string;
}

export interface TokenDistributionResponse {
  senderName: string;
  senderPhone: string;
  receiverName: string;
  receiverPhone: string;
  tokenAmount: number;
  createdAt: string;
  transactionId: string;
  transactionType: string;
}